import { useNavigate } from "react-router-dom";
import { useAuthorization } from "../identiyManagement/hooks";

export const useRedirectOnAuthenticated = () => {
    const navigate = useNavigate();
    const {isAuthenticated} = useAuthorization();
    if(isAuthenticated){
        navigate("/");
    }
};